import type { MouseEvent } from 'react';

/** "Skip to main content": hidden until focused, moves focus to `<main id="main">`. */
export function SkipLink() {
  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    document.getElementById('main')?.focus();
  };
  return (
    <a href="#main" className="skip-link" onClick={onClick}>
      Skip to main content
    </a>
  );
}
